<template>
  <div class="reports">
    <h1 class="page-title">Reports</h1>

  <div class="page-content">
    <h2 class="page-title">Monthly report for Dealership activity</h2>
    <div class="month-picker">
      <div class="month-picker__container">
        <div class="month-picker__year">
          <button type="button" @click="prevYear">‹</button>
          <p>
            {{year}}
          </p>
          <button type="button" @click="nextYear">›</button>
        </div>
        <table>
          <tbody>
            <tr>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'1')">
                January
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'2')">
                February
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'3')">
                March
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'4')">
                April
              </td>
            </tr>
            <tr>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'5')">
                May
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'6')">
                June
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'7')">
                July
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'8')">
                August
              </td>
            </tr>
            <tr>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'9')">
                September
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'10')">
                October
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'11')">
                November
              </td>
              <td class="month-picker__month" @click.prevent="fetchStats(year,'12')">
                December
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import api from "@/helpers/api";

const apiVersion = 'v1';
const source = 'reports';

export default {
  name: "Reports",
  props :{}
  ,
  data() {
    return {
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
        year: new Date().getFullYear()
    };
  },
  computed: {
    ...mapState({
      team: (state) => state.currentTeam
    })},
  methods: {
    async fetchStats(year, monthIndex) {
    api
        .instance()
        .get(`/${apiVersion}/${source}/per-delerpships/${year}/${monthIndex}`, { params: { team_id: this.team.currentTeam.hashid } })
        .then(({data}) => {
            const filename = 'dealership_report_' + year.toString() +'_'+ monthIndex.toString() +'.csv';
            const csvRows = [];
            const fileData = '\ufeff'; // Add unicode signature for Excel.
            const headers = 'dealership_id,dealership_name,date,convs,leads';
            csvRows.push(headers);
            data.forEach(value => {
              const values = Object.values(value).join(',');
              csvRows.push(values);
            });

            const blob = new Blob([fileData + csvRows.join('\n')], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('download', filename);
            a.click();
          }
        );
    },
    prevYear () {
      if (this.year > 2023) {
        this.year--;
      }
    },
    nextYear () {
      if (this.year < new Date().getFullYear()) {
        this.year++;
      }
    },
  }
};
</script>
<style>

.reports {
  span.value-box {
    display: block;
    padding: 10px;
    background: #f1f1f1;
    margin-top: 10px;
    word-break: break-all;
  }

  p.hint {
    font-size: 0.7em;
    margin: 0;
    padding: 0;
  }

  label {
    font-size: 0.9em;
  }

  .client-application {
    display: block;
    background: rgba(black, 0.05);
    padding: 10px;
    margin-bottom: 10px;

    > p {
      margin: 10px 0;
      word-wrap: break-word;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .month-picker {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px auto;
  }

  .month-picker__year {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;

    button {
      border: none;
      cursor: pointer;
      padding: 10px;
      width: 50px;
      border-radius: 5px;
      font-weight: bolder;
      font-size: 1.2em;
    }
    p {
      font-weight: bolder;
      font-size: 1.5em;
    }

  }

  .month-picker__container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .1);
    border-radius: 5px;
    padding: 10px;
  }

  .month-picker__month {
    padding: 10px;
    border-radius: 5px;
    margin: 5px;
    background-color: #f5f5f5;
    cursor: pointer;
    text-align: center;
    width: 150px;
    height: 50px;
    font-weight: bolder;
    border-block-style: groove;
    border-color: black;
  }
}
</style>
